import { z } from "zod";

import { newAddressSchema } from "./location";

export const contactAddressSchema = newAddressSchema.extend({
  contactId: z.number().nullable().default(null),
  // `null` means "create a new address"; a real id means the form is
  // editing that existing address instead.
  existingAddressId: z.number().nullable().default(null),
});

export type ContactAddressFormData = z.infer<typeof contactAddressSchema>;

export const defaultContactAddressFormData: ContactAddressFormData = {
  contactId: null,
  existingAddressId: null,
  place: "",
  street: "",
  extendedAddress: "",
  postOfficeBox: "",
  postalCode: "",
  city: "",
  country: "CH",
};

export function hasValidContactAddress(data: ContactAddressFormData): boolean {
  return Boolean(
    data.street.trim() && data.postalCode.trim() && data.city.trim(),
  );
}
